import { CustomerDoc } from '@livekatsomo/models';
import { LiveAvatar } from '@livekatsomo/web/ui-components/avatar';
import Delete from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

export interface CustomersProps {
  customers?: CustomerDoc[] | null;
  parentPath?: string;
  onDelete?: (customer: CustomerDoc) => void;
  onAddCustomer?: () => void;
}

export function CustomersCard({
  customers,
  parentPath,
  onDelete,
  onAddCustomer,
}: CustomersProps) {
  const { t } = useTranslation();
  return (
    <Card aria-labelledby="customers-card-header">
      <CardContent>
        <CardHeader title={t('Customers')} id="customers-card-header" />
        <List>
          {customers ? (
            customers.map((customer) => (
              <ListItemButton
                key={customer.id}
                LinkComponent={Link}
                href={`${parentPath}/${customer.slug}`}
              >
                <ListItem
                  secondaryAction={
                    onDelete && (
                      <IconButton
                        edge="end"
                        aria-label={t('delete') || 'delete'}
                        onClick={(e) => {
                          e.preventDefault();
                          onDelete(customer);
                        }}
                      >
                        <Delete />
                      </IconButton>
                    )
                  }
                >
                  <ListItemAvatar>
                    <LiveAvatar name={customer.name} asset={customer.logo} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={customer.name}
                    secondary={
                      <span>
                        {customer.description}
                        {customer.customerType === 'shop' ? (
                          <Chip
                            color="secondary"
                            sx={{ marginLeft: 2 }}
                            label={t('Shop')}
                            size="small"
                            component={'span'}
                          />
                        ) : null}
                      </span>
                    }
                  />
                </ListItem>
              </ListItemButton>
            ))
          ) : (
            <Typography>{t('There is no customers')}</Typography>
          )}
        </List>
      </CardContent>
      <CardActions>
        {onAddCustomer ? (
          <Button size="small" onClick={onAddCustomer}>
            {t('Add new')}
          </Button>
        ) : null}
      </CardActions>
    </Card>
  );
}

export default CustomersCard;
